"use client";

import ProductCard from "@/components/product-card";
import { Card } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import useRecentlyViewedProducts from "@/stores/recently-viewed-products";

export default function RecentlyViewedProducts() {
  const { products } = useRecentlyViewedProducts();

  if (products.length == 0) return null;

  return (
    <Card>
      <div className="flex items-center justify-between gap-3 px-4 py-4">
        <div className="text-xl font-semibold">Recently Viewed</div>
      </div>
      <div className="px-4">
        <Swiper
          modules={[Autoplay, Navigation]}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          spaceBetween={16}
          slidesPerView="auto"
          loop
          navigation
        >
          {products.map((product, index) => (
            <SwiperSlide
              className="md:max-w-[300px] max-w-[165px] pb-8"
              key={index}
            >
              <ProductCard product={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Card>
  );
}
